import _defineProperty from "babel-runtime/helpers/defineProperty";
var init = function init(options) {
  this.telinput(options);
  options.disabled ? this.setDisabled() : this.setEnabled();
};
export default {
  name: "kui-telinput",
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    titleName: function titleName() {
      return this.options.title ? this.options.title + ":" : "";
    },
    telCodewidth: function telCodewidth() {
      return parseInt(this.options.width || 180) - 167;
    }
  },
  mounted: function mounted() {
    init.call(this, this.options);
  },

  methods: {
    telinput: function telinput(opts) {
      var _this = this;

      if (_.isString(opts)) {
        if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1) {
          this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
        } else {
          this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1]);
        }
      } else {
        _.assign(this.options, opts);
        _.each(this.options, function (v, k) {
          if (!_.isFunction(v) && k == "value") {
            _this.setValue(v);
          }
        });
      }
    },
    validate: function validate() {
      return !_.chain(this.$children).map(function (compoment) {
        return compoment.validate();
      }).some(function (flag) {
        return flag === false;
      }).value();
    },

    getValue: function getValue() {
      var areaCode = this.$refs.AREA_CODE.getValue(),
          telCode = this.$refs.TEL_CODE.getValue();
      return areaCode ? areaCode + "-" + telCode : telCode;
    },
    setValue: function setValue(value) {
      if (!value) {
        this.clear();
      } else {
        var index = value.indexOf("-");
        if (index !== -1) {
          this.$refs.AREA_CODE.combobox("setValue", value.substring(0, index));
          this.$refs.TEL_CODE.textinput("setValue", value.substring(++index));
        } else {
          this.$refs.TEL_CODE.textinput("setValue", value);
        }
      }
      this.validate();
    },
    setEnabled: function setEnabled() {
      _.each(this.$children, function (compoment) {
        return compoment.setEnabled();
      });
    },
    setDisabled: function setDisabled() {
      _.each(this.$children, function (compoment) {
        return compoment.setDisabled();
      });
    },
    clear: function clear() {
      _.each(this.$children, function (compoment) {
        return compoment.clear();
      });
    },
    getData: function getData() {
      return _defineProperty({}, this.options.field, this.getValue());
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/telinput/src/telinput.js
// module id = 1500
// module chunks = 2